<template>
  <!-- Fade in header initially -->
  <div class="fade-in-initial">
    <div class="header-text-container">
      <div class="subsection left">
        <div class="bar left" :style="leftStyle"/>
        <div class="header-text left" :style="textStyle">
          P R O J E C T
        </div>
      </div>
      <div class="subsection right">
        <div class="header-text right" :style="textStyle">
          S Y N T H E C I T E
        </div>
        <div class="bar right" :style="rightStyle"/>
      </div>
    </div>
    <div class="header" ref="header" :style="headerStyle">
      <div class="background">
        <div class="overlay" :style="overlayStyle">
          <img :src="banner" class="overlay-image" />
        </div>
        <img :src="banner" />
      </div>
      <transition name="title"></transition>
    </div>
  </div>
</template>

<script>
/**
 * The header banner for the website
 */
import StoreUtils from "@/scripts/utils/store"
import ScrollController from "@/scripts/scroll-transition-controller"
export default {
  data() {
    return {
      bannerSrc: "",
      scrollController: null,
      overlayScrollController: null,
      titleScrollController: null,
      storeWatch: null
    }
  },
  computed: {
    banner() {
      return require("@/assets/project-synthecite/" + this.bannerSrc)
    },
    headerStyle() {
      let opacity = this.scrollController
        ? 1 - this.scrollController.scrollProgress
        : 1
      return {
        opacity
      }
    },
    rightStyle() {
      return {
        ...this.textStyle,
        ...this.getBarStyle(30),
      }
    },
    leftStyle() {
      return {
        ...this.textStyle,
        ...this.getBarStyle(40),
      }
    },
    overlayStyle() {
      let opacity = this.overlayScrollController
        ? this.overlayScrollController.scrollProgress * 1.5
        : 1
      if (opacity === 0) {
        return { opacity }
      } else {
        return {
          opacity
        }
      }
    },
    textStyle() {
      let prog = this.titleScrollController.scrollProgress
      let opacity = 1
      const ENDPER = 0.75
      const BEGPER = 0.5
      if (prog > ENDPER) {
        opacity = this.lerp(1, 0, (prog-ENDPER)/(1-ENDPER))
      } else if(prog < BEGPER) {
        opacity = this.lerp(0.5, 1, prog/BEGPER)
      }
      return {
        opacity,
      }
    },
    headerTextStyle() {
      let prog = this.titleScrollController.scrollProgress
      let paddingTop = this.lerp(93, 15, prog)
      return {
        "padding-top": `${paddingTop}vh`
      }
    }
  },
  created() {
    // Setup scroll and glitch util stuffs
    this.storeWatch = StoreUtils.WatchGlitch(this.glitchFunc, this.unglitchFunc)
    this.scrollController = new ScrollController(this.$refs, "header", {
      anchor: "bottom",
      completeScrollPercentage: 0.7
    })
    this.overlayScrollController = new ScrollController(this.$refs, "header", {
      anchor: "bottom",
      completeScrollPercentage: 0.5
    })
    this.titleScrollController = new ScrollController(this.$refs, "header", {
      anchor: "bottom",
      completeScrollPercentage: 0.85
    })
    this.unglitchFunc()
  },
  beforeDestroy() {
    this.scrollController.destroy()
    this.overlayScrollController.destroy()
    this.storeWatch()
  },
  methods: {
    glitchFunc() {
      this.bannerSrc = "header.png"
    },
    unglitchFunc() {
      this.bannerSrc = "header.png"
    },
    lerp(a,b, t) {
      return a + (b-a)*t
    },
    getBarStyle(max) {
      let t = this.overlayScrollController.scrollProgress
      let transitionSpeed = 1
      if (t > 0.5) {
        t= 1
      } else {
        t= 0
      }
      let width  =this.lerp(0,max, t)
      return {
        ...this.textStyle,
        width: `${width}%`,
        transition: `width ${transitionSpeed}s`,
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

.fade-in-initial {
  opacity: 0;
  animation: 1.5s fadein ease forwards;
  animation-delay: 0.25s;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.header {
  height: 100vh;
  margin-bottom: 50px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgb(179, 0, 0);
  transition: 0.5s opacity;
}
.overlay img {
  mix-blend-mode: color-burn;
  display: block;
}
.background img,
.overlay {
  width: 100vw;
  height: auto;
  /* center it */
  margin-left: 50%;
  transform: translateX(-50%);
}
.overlay {
  width: 100%;
}

.title {
  animation: 1s appear;
  font-size: 100px;
  color: white;
  text-shadow: -5px 4px 0px black;
  position: absolute;
  top: 20px;
  right: 40px;
}

@keyframes appear {
  0% {
    transform: translateY(25px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

.header-text-container { 
  position: absolute;
  width: 100%;
  z-index: 1000;
  padding-top: 93vh;
  text-align: center;
  display: flex;
  align-items:center;
  justify-content: space-between;
  transition: 0.2s padding-top;

  .subsection {
    display: flex;
    align-items:center;

    &.left {
      width:77%;
      margin-left: 5vw;
      justify-content: flex-start;
    }
    &.right {
      width: 100%;
      margin-right: 5vw;
      flex-grow: 1;
      justify-content: flex-end;
    }
  }
}


.header-text {
  color: $green;
  font-size: min(6vw, 8vh);
  text-align: justify;
  position:relative;
  transition:0.2s all;
  text-shadow: 0 0 20px rgba($text-color, 0.7);
  flex-shrink: 0;

  &.left { 
    margin-right: 2vw;
  }
  &.right {
    margin-left: 2vw;
  }
  
}
$margin-width: 2vw;
.bar {
  height: 5px;
  border: None;
  background-color: $green;
  transition-timing-function: ease-in;
  &.left {
    margin-right: $margin-width;
  }
  &.right {
    margin-left: $margin-width;
  }
}


/** RESPONSIVE */
@media only screen and (max-width: 1700px) {
  .background img {
    width: auto;
    height:100vh;
  }

  .header-text-container  {
    padding-top: 80vh;
    flex-direction: column;
    .subsection {
      &.left {
        width:100%;
        margin-left: 20%;
      }
      &.right {
        margin-right: 20%;
      }
    }
    .header-text {
      &.left {
        margin-right: 0;
      }
      &.right {
        margin-left: 0;
      }
    }

    .bar {
      max-width: 10%;
    }
  }
}
@media only screen and (max-width: 900px) {
  .header-text-container  {
    flex-direction: column;
    .subsection {
      &.left {
        margin-left: 10%;
      }
      &.right {
        margin-right: 10%;
      }
    }
  }
}
@media only screen and (max-width: 500px) {
  .header-text-container {
    .header-text {
      font-size: 10vw;
    }
    .subsection {

      &.right {
        margin-right: 0%;
        margin-left: 10%;
        justify-content: flex-start;
      }
    }
    .bar {
      max-width: 10%;
    }
  }
}
</style>
